import React, { Component } from 'react';
import * as _ from 'lodash';
import * as GA from 'react-ga';

import { 
	Form, 
	Header, 
	Button, 
	Icon, 
	Divider, 
	Segment, 
	Container,
	Checkbox } from 'semantic-ui-react';
import isEmail from 'validator/lib/isEmail';

export class EmailCapture extends Component
{
	cta = [
		'Enter your email above',
		'Select your platforms',
		'Get Early Access Now!'
	]

	constructor()
	{
		super();

		this.state = {
			ctaNum: 0,
			cta: this.cta[0],
			ctaReady: false,
			platforms: []
		}

		this.handlEmailChange = _.debounce(this.handlEmailChange, 400).bind(this);
		this.handleEmailSubmit = this.handleEmailSubmit.bind(this);
		this.handlePlatformChange = this.handlePlatformChange.bind(this);
	}

	handlePlatformChange(e, data)
	{
		console.log(e);
		console.log(data);

		let p = this.state.platforms;

		if (data.checked)
		{
			p.push(data.name);
		}
		else
		{
			let idx = p.lastIndexOf(data.name);
			p.splice(idx, 1);
		}

		this.setState({
			platforms: p
		});

		console.log(p);

		let ctaNum = this.state.ctaNum;
		let hasPlatforms = p.length > 0;
		if (!hasPlatforms)
		{
			ctaNum = 1;
		}

		ctaNum = hasPlatforms && ctaNum === 1 ? 2 : ctaNum;

		let ready = ctaNum === 2;

		this.setState({
			ctaNum: ctaNum,
			cta: this.cta[ctaNum],
			ctaReady: ready
		});
	}

	handleEmailSubmit(e)
	{
		GA.event({
			category: 'early_access',
			action: 'joined',
			label: 'pressed button to submit email'
		});
	}

	handlEmailChange(e, { name, value })
	{
		console.log(e);
		this.setState({ [name]: value });

		const validEmail = isEmail(value);

		console.log(value + ' - ' + validEmail);

		let ctaNum = validEmail ? 1 : 0;
		ctaNum = this.state.platforms.length > 0 && validEmail ? 2 : ctaNum;

		let ready = ctaNum === 2;

		this.setState({
			ctaNum: ctaNum,
			cta: this.cta[ctaNum],
			ctaReady: ready
		});

		if (ctaNum === 1)
		{
			GA.event({
				category: 'early_access',
				action: 'entered_email',
				label: 'entered email in email capture'
			});
		}
	}

	render()
	{
		return (
			<div>
			<Segment basic inverted className='captivate-green-bg' id='beta-access'>
				<Container>
					<Segment basic size='large'>
						<Header color='black' as='h1' textAlign='center'>
							Join Our Early Access Program!
						</Header>
						<p>Get <b>early access</b> to all our games as a member of the Early Access Program! You'll have the chance to provide insights and feedback to the team while games are in development. Early Access members are also notified first about any <b>in-game exclusives or free swag</b> that we may give away!</p>
						<p>It is our mission to make games that you'll love. <Icon color='red' name='heart'/>Your feedback is very important to us. Join today to help us create <b>better games</b>!</p>
						<p>Our Early Access Program is completely <b>free</b>. We just need an email where we can reach you.</p>
						<small>We will never sell your email to third parties and only email you information about our games at Captivate.</small>
					</Segment>
					<Form className='ui form' action='//games.us15.list-manage.com/subscribe/post?u=5e1e551fe9d46155d2b94d2e7&amp;id=f997fe0a31' method='post' name="mc-embedded-subscribe-form" target='_self'>
					<Form.Group size='big' widths='equal'>
						<Form.Input placeholder='Email' icon='mail' iconPosition='left' name='EMAIL' size='big' onChange={this.handlEmailChange}/>
					</Form.Group>
					<Form.Field>
						<Header as="h3">
							Which platforms are you interested in?
						</Header>
					</Form.Field>
					<Form.Field>
						<Checkbox 
							type="checkbox" 
							value="1" 
							name="group[2833][1]" 
							label="iOS (iPhone/iPad)" 
							onChange={this.handlePlatformChange} 
							checked={_.findIndex(this.state.platforms, function (o) {return o === 'group[2833][1]'}) > -1} />
					</Form.Field>
					<Form.Field>
						<Checkbox 
							type="checkbox" 
							value="4" 
							name="group[2833][4]" 
							label="Android" 
							onChange={this.handlePlatformChange} 
							checked={_.findIndex(this.state.platforms, function (o) {return o === 'group[2833][4]'}) > -1} />
					</Form.Field>
					<Button disabled={!this.state.ctaReady} animated='fade' primary fluid onClick={this.handleEmailSubmit}>
						<Button.Content visible>{this.state.cta}</Button.Content>
						<Button.Content hidden>
							<Icon name='winner' />
							Let's do it!
						</Button.Content>
					</Button>
					</Form>
				</Container>
				<Divider hidden/>
			</Segment>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/EmailCapture.js